export default [
  {
    path: '/zhyMachine',
    redirect: '/zhyMachine/index',
    component: {
      render() {
        return (
          <keep-alive include={this.$store.state.viewsCache.caches}>
            <router-view />
          </keep-alive>
        );
      },
    },
    children: [
      {
        path: 'index',
        name: 'Machine',
        component: () => import('@/views/zhyMachine/index'),
      },
      // 机具查询
      {
        path: 'query',
        name: 'ZhyMachineQuery',
        component: () => import('@/views/zhyMachine/query'),
      },
      // 机具搜索
      {
        path: 'search',
        name: 'ZhyMachineSearch',
        component: () => import('@/views/zhyMachine/search'),
      },
      // 机具转让
      {
        path: 'assign',
        name: 'ZhyMachineAssign',
        component: () => import('@/views/zhyMachine/assign'),
      },
      {
        path: 'chooseReceiver',
        name: 'ChooseReceiver',
        component: () => import('@/views/zhyMachine/chooseReceiver'),
      },
      {
        path: 'result',
        name: 'AssignResult',
        component: () => import('@/views/zhyMachine/result'),
      },
      // 转让记录
      {
        path: 'record',
        name: 'ZhyAssignRecord',
        component: () => import('@/views/zhyMachine/record'),
      },
      // 机具接收
      {
        path: 'receive',
        name: 'ZhyMachineReceive',
        component: () => import('@/views/zhyMachine/receive'),
      },
      // 扣款记录
      {
        path: 'deduction',
        name: 'DeductionList',
        component: () => import('@/views/zhyMachine/deduction'),
      },
      {
        path: 'deductionDetail',
        name: 'DeductionDetail',
        component: () => import('@/views/zhyMachine/deduction/deductionDetail'),
      },
      // 转让详情
      {
        path: 'assignDetail/:type',
        name: 'ZhyMachineAssignDetail',
        component: () => import('@/views/zhyMachine/assignDetail'),
      },
      // 机具详情
      {
        path: 'detail/:id',
        name: 'ZhyMachineDetail',
        component: () => import('@/views/zhyMachine/detail'),
      },
      // xyfActive
      {
        path: 'xyfActive',
        name: 'xyfActive',
        component: () => import('@/views/zhyMachine/xyfActive'),
      },
      {
        path: 'xyfActivedetail',
        name: 'xyfActivedetail',
        component: () => import('@/views/zhyMachine/xyfActivedetail'),
      },
      // 设置机具活动
      {
        path: 'setActive',
        name: 'SetActive',
        component: () => import('@/views/zhyMachine/setActive'),
      },
      // 设置机具活动结果页面
      {
        path: 'activeResult',
        name: 'ActiveResult',
        component: () => import('@/views/zhyMachine/setActive/activeResult'),
      },
      //我的申领页面
      {
        path: 'machineApply',
        name: 'MachineApply',
        component: () => import('@/views/zhyMachine/apply/tileStack/tileStackDetalis'),
      },
      //新增申领页面
      {
        path: 'applyAdd',
        name: 'ApplyAdd',
        component: () => import('@/views/zhyMachine/apply/tileStack/addPage'),
      },
      //我的申领记录
      {
        path: 'applyList',
        name: 'ZhyApplyList',
        component: () => import('@/views/zhyMachine/apply/index'),
      },
      // 达标跟进
      {
        path: 'pursue',
        name: 'ZhyMachinePursue',
        component: () => import('@/views/zhyMachine/pursue'),
      },

    ],
  },
];
